import { useQuery } from '@tanstack/react-query';
import { getTutorials } from './endpointsTutorials';
import { refetchDelayMs } from './schemasTutorials';
import { qk } from './queryKeys';

/* ---------- Tutorials (SPEC decision 20) ---------- */

/**
 * The published lessons. Their media are signed URLs that expire at `mediaExpiresAt`, so the manifest is fetched
 * again shortly before (an interval while the tab is open, and staleness so a focus after a long absence refreshes it).
 */
export const useTutorials = () =>
  useQuery({
    queryKey: qk.tutorials,
    queryFn: getTutorials,
    staleTime: (query) => refetchDelayMs(query.state.data?.mediaExpiresAt, Date.now()),
    refetchInterval: (query) => refetchDelayMs(query.state.data?.mediaExpiresAt, Date.now()),
  });
